/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AddFittingComponent } from '../add-fitting-size/add-fitting.component';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { ActionPageEnumDto, ActionTypeEnumDto } from 'api/models';
import { FittingsManagementService } from 'api/services';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-update-fitting-size',
  templateUrl: './update-fitting-size.component.html'
})
export class UpdateFittingSizeComponent extends AddFittingComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) onUpdateContextMenu: MatMenuTrigger;
  onUpdateContextMenuPosition = { x: '0px', y: '0px' };
  selectedExistingFitting;

  ngOnInit() {
    this.refreshSubscription = this.fittingSizeManagementService.getFittingTableData().subscribe(
      () => {
        this.refresh();
        this.selectedRowCopy = this.fittingSizeManagementService.getSelectedRowCopy();
      }
    );
    this.actionPage = ActionPageEnumDto.Update;
    this.actionType = ActionTypeEnumDto.UndoUpdate;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();
    this.fittingSizeManagementService.setActionPage(this.actionPage);

  }
  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    super(dialog, userHandlerService, fittingsManagementService, genericTableDataService,
      fittingSizeDataService, fittingSizeManagementService, authentificationService, loaderService);
  }

  getFittingType() {
    return this.fittingSizeManagementService.getSelectedFittingType();
  }

  onUpdateContextMenuClick(event) {
    this.onUpdateContextMenuPosition.x = event.mouseEvent.clientX + 'px';
    this.onUpdateContextMenuPosition.y = event.mouseEvent.clientY + 'px';
    this.selectedExistingFitting = event.element;
    // tslint:disable-next-line: object-literal-key-quotes
    this.onUpdateContextMenu.menuData = { 'element': event.element };
    this.onUpdateContextMenu.openMenu();
  }

  onUpdateAction(selectedSize: any) {
    this.fittingSizeManagementService.setExistingFittingSize(selectedSize);
  }

  getPartialSaveActionType() {
    return ActionTypeEnumDto.PartialSaveUpdate;
  }

  getSentForAproveActionType() {
    return ActionTypeEnumDto.SendForApproveUpdatedSize;
  }

  getDeleteActionType() {
    return ActionTypeEnumDto.RemoveUpdatedAfterPartialSave;
  }
}
